import { DataObjectFactory } from "@/v2/models/base-data-object.js";
import { Media } from "@/v2/models/medias.js";
import httpMixin from "@/v2/mixins/http.js";
import { MediaFactory, MediaMapperParameter } from "@/v2/models/medias";
import mapperMixin from "@/v2/mixins/mapper.js";

export default {
    mixins: [httpMixin, mapperMixin],
    data() {
        return {
            mediasUrl: window.bo?.mediasUrl,
            currentRoute: window.bo?.currentRoute ?? null,
        };
    },
    methods: {
        _mediaMapper(media) {
            return {
                id: media.id,
                source_url: media.source_url,
                source_url_small: media.source_url_small,
                source_url_medium: media.source_url_medium,
                source_url_large: media.source_url_large,
                title: media.title,
                embed_link: media.embed_link ?? "",
                hash: media.hash,
                position: media.position,
            };
        },

        parseMedia(media) {
            return MediaFactory.construct(this.createMapperParameter(new MediaMapperParameter()), media);
        },

        parseMedias(medias) {
            let parsedMedias = [];

            medias.forEach((mediaData) => {
                const media = this.parseMedia(mediaData);
                parsedMedias.push(media);
            });

            return parsedMedias;
        },

        getMedias(payload, success, failure) {
            return this.getData(
                this.mediasUrl,
                payload,
                (response) => {
                    success(this.parseMedias(response.data));
                },
                failure
            );
        },

        async createMedia(file, success, failure) {
            let formData = new FormData();
            formData.append("file", file, file.name);
            formData.append("currentRoute", this.currentRoute);
            try {
                const response = await this.post(this.mediasUrl, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                });
                const media = this.parseMedia(response.data);
                if (success) {
                    return success(media);
                }
                return media;
            } catch (error) {
                const translations = this.generalTranslations ?? window.bo?.generalTranslations;
                this.handleError(
                    error,
                    translations?.upload_media_failure,
                    translations?.upload_media_failure
                );
            }
        },

        async updateMediaRotation(rotation, id, success, failure) {
            let formData = new FormData();
            formData.append("rotation", rotation);
            formData.append("id", id);
            formData.append("currentRoute", this.currentRoute);
            try {
                const response = await this.post(this.mediasUrl + "/update-image-rotation", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                });
                const media = this.parseMedia(response.data);
                if (success) {
                    return success(media);
                }
                return media;
            } catch (error) {
                if (failure) {
                    return failure();
                }
                const translations = this.generalTranslations ?? window.bo?.generalTranslations;
                this.handleError(
                    error,
                    translations?.rotate_media_failure,
                    translations?.rotate_media_failure
                );
            }
        },
    },
};
